import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { FetchConfig, SetApiUrl, SetGoogleClientId } from "./settings";

const root = ReactDOM.createRoot(document.getElementById('root'));

FetchConfig("/config.json")
.then((data) => {
  SetApiUrl(data.api_url)
  SetGoogleClientId(data.google_client_id)

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
})
.catch(() => {
  root.render(
    <React.StrictMode>
      <div>Failed to fetch config</div>
    </React.StrictMode>
  );
})
